export const styles = {
	container: 'flex flex-col gap-xs',
	text: 'whitespace-pre-wrap',
	toolBlock: 'group rounded-lg border border-subtle bg-white font-mono text-[12px] not-italic',
	toolSummary: 'flex cursor-pointer items-center gap-2xs rounded-md px-xs py-2xs transition-colors hover:bg-grey-25',
	toolName: 'text-[12px] font-semibold text-default',
	toolBody: 'border-t border-subtle px-xs py-xs',
	toolLabel: 'mb-3xs font-sans text-[10px] font-medium uppercase tracking-wider text-subtle',
	toolPre: 'overflow-x-auto whitespace-pre-wrap rounded-md bg-grey-25 px-xs py-xs text-[11px] text-default',
	rawPre:
		'overflow-x-auto whitespace-pre-wrap rounded-md bg-grey-25 px-xs py-xs font-mono text-[11px] not-italic text-default',
};
